// third-party
import { Trans } from 'react-i18next';

// assets
import { IconHistory, IconScan, IconReport, IconGiftCard, IconDeviceGamepad2 } from '@tabler/icons';

// constant
const icons = {
    IconHistory,
    IconScan,
    IconReport,
    IconGiftCard,
    IconDeviceGamepad2,
};

// ==============================|| MENU ITEMS ||============================== //

const event = {
    id: 'events',
    title: <Trans i18nKey="Events" id="Events" />,
    type: 'group',
    children: [
        {
            id: "customer-survey-responses",
            title: (
                <Trans
                    i18nKey="Customer survey"
                    id="Customer survey"
                />
            ),
            type: "item",
            url: "/customer-survey-responses",
            icon: icons.IconGiftCard,
            breadcrumbs: false,
        },
        // {
        //     id: 'events',
        //     title: <Trans i18nKey="Game event" id="Game event" />,
        //     type: 'collapse',
        //     url: '/events',
        //     icon: icons.IconDeviceGamepad2,
        //     breadcrumbs: false,
        //     children: [
        //         {
        //             id: 'events',
        //             title: (
        //                 <>
        //                     <Trans i18nKey="Events List" id="Events List" />
        //                 </>
        //             ),
        //             type: 'item',
        //             url: '/events',
        //             breadcrumbs: false,
        //         },
        //         {
        //             id: 'event-products',
        //             title: (
        //                 <>
        //                     <Trans i18nKey="Gifts List" id="Gifts List" />
        //                 </>
        //             ),
        //             type: 'item',
        //             url: '/event-products',
        //             breadcrumbs: false,
        //         },
        //         {
        //             id: 'gift-card-event-logs',
        //             title: (
        //                 <>
        //                     <Trans i18nKey="History" id="History" />
        //                 </>
        //             ),
        //             type: 'item',
        //             url: '/event-logs',
        //             breadcrumbs: false,
        //         },
        //     ]
        // },
        {
            id: 'gift-card-events',
            title: <Trans i18nKey="Gift card events" id="Gift card events" />,
            type: 'collapse',
            url: '/gift-card-events',
            icon: icons.IconGiftCard,
            breadcrumbs: false,
            children: [
                {
                    id: 'gift-card-events',
                    title: (
                        <>
                            <Trans i18nKey="Event list" id="Event list" />
                        </>
                    ),
                    type: 'item',
                    url: '/gift-card-events',
                    breadcrumbs: false,
                },
                {
                    id: 'gift-card-event-products',
                    title: (
                        <>
                            <Trans i18nKey="Gifts List" id="Gifts List" />
                        </>
                    ),
                    type: 'item',
                    url: '/gift-card-event-products',
                    breadcrumbs: false,
                },
                {
                    id: 'gift-card-event-logs',
                    title: (
                        <>
                            <Trans i18nKey="History" id="History" />
                        </>
                    ),
                    type: 'item',
                    url: '/gift-card-event-logs',
                    breadcrumbs: false,
                },
                {
                    id: 'gift-card-event-statistics',
                    title: (
                        <>
                            <Trans i18nKey="Statistics" id="Statistics" />
                        </>
                    ),
                    type: 'item',
                    url: '/gift-card-event-statistics',
                    breadcrumbs: false,
                },
            ]
        },
    ]
};

export default event;
